import { render, staticRenderFns } from "./TaxTypesSetting.vue?vue&type=template&id=44e1b6ee&"
import script from "./TaxTypesSetting.vue?vue&type=script&lang=js&"
export * from "./TaxTypesSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Development/2020/invoicing/crater-20201222/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44e1b6ee')) {
      api.createRecord('44e1b6ee', component.options)
    } else {
      api.reload('44e1b6ee', component.options)
    }
    module.hot.accept("./TaxTypesSetting.vue?vue&type=template&id=44e1b6ee&", function () {
      api.rerender('44e1b6ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/settings/TaxTypesSetting.vue"
export default component.exports